<template>
  <div style="margin-top: 71px;">
    <div>
      <div v-if="bgUrl != null" class="page-start" :style="{ backgroundImage:'url('+bgUrl+')'}">
      </div>
      <div v-if="bgUrl == null"  class="page-start">
      </div>
      <div class="wrap">
        <my-breadcrumb :id="id"></my-breadcrumb>

        <div class="box-wrapper">
          <div class="box-left">
            <div class="box-left-title">
              {{ info.title }}
            </div>
            <div class="box-left-sub-title">
              {{ info.subTitle }}
            </div>
            <tiny-button type="warning" round size="medium" class="link-us-btn" @click="handleLinkUs"> 联系我们 -></tiny-button>

          </div>
          <div class="box-right">
            <img :src="info.imgUrls">
          </div>

        </div>
      </div>

      <div class="line-wrap"></div>

      <div class="wrap" >
        <div v-if="info.videos" class="wrap-detail">
          <Videoplayer :mp4Url="info.videos"></Videoplayer>
        </div>
        <div class="wrap-detail" v-html="info.detail">

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  Layout as TinyLayout,
  Row as TinyRow,
  Col as TinyCol,
  Image,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Tabs,
  TabItem,
  Tooltip
} from '@opentiny/vue'
import MyBreadcrumb from "@/components/MyBreadcrumb.vue";
import request from "@/utils/request";
import Videoplayer from "@/components/Video";

export default {
  name: "Template3",
  components: {
    Videoplayer,
    MyBreadcrumb,
    TinyLayout,
    TinyRow,
    TinyCol,
    TinyImage: Image,
    TinyButton: Button,
    TinyBreadcrumb: Breadcrumb,
    TinyBreadcrumbItem: BreadcrumbItem,
    TinyTabs: Tabs,
    TinyTabItem: TabItem,
    TinyTooltip: Tooltip
  },
  data() {
    return {
      info: {},
      bgUrl: '',

      id: '',
      breadcrumbs: [],
      phone: '',
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function (to, from) {
        this.init(to.query.id.toString());
      }
    }
  },
  created() {
    if(sessionStorage.getItem("phone")){
      this.phone = sessionStorage.getItem("phone");
    }
  },
  computed: {},
  mounted() {

  },
  methods: {
    init(id) {
      this.id = id;
      this.queryTemplate3();
    },

    async queryTemplate3() {
      const {data} = await request.get("/outSiteMenu/queryTemplate3/" + this.id)
      console.log(data);
      if (data.code === 200 && data.data) {
        this.info = data.data.info;
        this.bgUrl = data.data.bgUrl;
      }
    },

    handleLinkUs(){
      // this.$router.push({path: '/page3', query: {id: 8}});
      this.$router.push({path: '/page1', query: {id: 4539}});
    },
  }
};
</script>

<style scoped>

.wrap {
  max-width: 1180px;
  text-align: center;
  min-height: 300px;
  margin: 0 auto;
}

.page-start {
  background: url(~@/assets/images/about-us-start.jpg) no-repeat center;
  background-size: 100% 100%;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  aspect-ratio: 4.8;
}

.box-wrapper {
  height: 300px;
  margin: 50px 0;
  display: flex;
  text-align: left;
  position: relative;
}

.box-left {
  flex: 1;
  padding: 20px;
}

.box-left-title {
  font-size: 20px;
  font-weight: bold;
  color: #214b85;
  padding: 20px 0;
}

.box-left-sub-title {
  color: #777;
  line-height: 2rem;
}


.box-right {
  height: 300px;
  width: 533px;
}

.box-right img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.link-us-btn {
  position: absolute;
  bottom: 20px;
  left: 20px;
}

.line-wrap{
  width: 80%;
  margin: 0 auto;
  height: 1px;
  border-bottom: 1px solid #e2e2e2;
}

.wrap-detail{
  margin: 50px 0;
  text-align: left;
  line-height: 2rem;
}

.box-left >>> .tiny-tooltip.custom-transition-enter,
.box-left >>> .tiny-tooltip.custom-transition-enter-from,
.box-left >>> .tiny-tooltip.custom-transition-leave-to {
  opacity: 0;
  transform: translateX(-999px);
  transform-origin: center top;
}

.box-left >>> .custom-transition-enter-active,
.box-left >>> .custom-transition-leave-active {
  opacity: 1;
  transform: translateX(0);
  transition: transform 1s cubic-bezier(0.23, 1, 0.32, 1), opacity 1s cubic-bezier(0.23, 1, 0.32, 1);
}
</style>
